import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { SidebarProvider, useSidebar } from "../../hooks/SidebarContext";
import {
  LOGIN,
  DASHBOARD,
  INVENTORY,
  REQUESTS,
  SUPPLIER,
  USERS,
  TOOLS,
  ORGANIZATION,
  PROFILE,
  GLOBAL_SEARCH,
} from "../../routes/RouteConstant";

function LayoutShell() {
  const { isCollapsed } = useSidebar();
  const location = useLocation();

  const routeNames = {
    [DASHBOARD]: "Dashboard",
    [INVENTORY]: "Inventory",
    [REQUESTS]: "Requests",
    [SUPPLIER]: "Suppliers",
    [USERS]: "Users",
    [TOOLS]: "Tools",
    [ORGANIZATION]: "Organization",
    [PROFILE]: "Profile",
    [LOGIN]: "Login",
    [GLOBAL_SEARCH]: "Global Search",
  };

  const pageTitle = routeNames[location.pathname] || "Dashboard";

  return (
    <div className="min-h-screen w-full bg-[#05070B] font-['IBM_Plex_Sans']">
      <Sidebar />
      <div
        className={`flex min-h-screen flex-col bg-[#FAF8F3] transition-all duration-300 ease-in-out ${
          isCollapsed ? "lg:pl-[76px]" : "lg:pl-64"
        }`}
      >
        <Navbar pageTitle={pageTitle} />
        <main className="flex-1 px-4 py-5 sm:px-6 sm:py-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default function DashboardLayout() {
  return (
    <SidebarProvider>
      <LayoutShell />
    </SidebarProvider>
  );
}
